/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const StarFilledColoredBoldIcon = /*#__PURE__*/ createSvgIcon(
  'StarFilledColoredBoldIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <path
            d="M13.63 6.32h-4L8.3 2.22a.33.33 0 00-.547-.143.35.35 0 00-.083.123L6.32 6.32h-4a.34.34 0 00-.32.32.36.36 0 00.12.27L5.5 9.49l-1.3 4.08a.33.33 0 00.23.41.358.358 0 00.3-.05L8 11.39l3.28 2.54a.33.33 0 00.46 0 .3.3 0 00.06-.31l-1.31-4.13 3.37-2.58a.32.32 0 00.08-.45.34.34 0 00-.31-.14z"
            fill="#F2D049"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.566 1.05a1.33 1.33 0 011.688.87l1.103 3.4h3.24a1.34 1.34 0 011.155.557l.002.002a1.32 1.32 0 01-.3 1.836l-2.799 2.142 1.093 3.443a1.3 1.3 0 01-.273 1.308l-.019.02-.019.02a1.33 1.33 0 01-1.799.05l-2.637-2.043-2.68 2.083-.025.017a1.36 1.36 0 01-1.598-.045 1.33 1.33 0 01-.459-1.418l.004-.013 1.09-3.421-2.85-2.177-.03-.026A1.36 1.36 0 011 6.635V6.61l.002-.026a1.34 1.34 0 011.26-1.261l.03-.002h3.303L6.73 1.857l.012-.03a1.35 1.35 0 01.81-.772l.007-.002.007-.003zM4.164 14.944h-.002l.268-.964-.264.965-.002-.001zM7.979 4.47l-.934 2.85h-2.74l2.362 1.802-.863 2.707L8 10.124l2.178 1.687-.853-2.688L11.68 7.32H8.903L7.98 4.47z"
            fill="#7C6919"
          />
        </>
      ),
      medium: ({ id }) => (
        <>
          <path
            d="M17.646 7.78l-5.456-.01-1.78-5.46a.45.45 0 00-.85 0l-1.8 5.46H2.45A.45.45 0 002 8.2a.43.43 0 00.16.35L6.66 12l-1.72 5.43a.45.45 0 00.3.56.43.43 0 00.39-.08L10 14.53l4.38 3.38a.44.44 0 00.69-.48L13.33 12l4.49-3.44a.43.43 0 00-.31-.78h.136z"
            fill="#F2D049"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.145 1.276a1.45 1.45 0 012.21.705l.002.01 1.559 4.78 4.543.008a1.43 1.43 0 01.953 2.587l-3.915 3 1.526 4.762a1.44 1.44 0 01-2.255 1.573l-.003-.003L10 15.794l-3.752 2.901a1.43 1.43 0 01-1.285.256l-.007-.002-.008-.002a1.45 1.45 0 01-.967-1.805l.002-.007 1.51-4.768-3.952-3.03-.01-.008A1.43 1.43 0 011 8.165v-.01A1.45 1.45 0 012.45 6.77h4.587l1.576-4.78.002-.009a1.45 1.45 0 01.53-.705zm6.748 7.5l-3.704-.006v-1l-.001 1-.724-.001-1.482-4.545L8.483 8.77H4.09l3.735 2.863-1.39 4.39 3.564-2.757 3.569 2.754-1.405-4.386 3.73-2.857z"
            fill="#7C6919"
          />
        </>
      ),
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <path
              d="M21.39 9.21h-6.65l-2.23-6.84A.56.56 0 0011.8 2a.55.55 0 00-.34.34L9.2 9.21H2.57a.55.55 0 00-.37 1l5.63 4.3-2.16 6.8a.55.55 0 00.38.69.541.541 0 00.49-.09L12 17.65l5.47 4.23a.54.54 0 00.86-.6l-2.17-6.8 5.61-4.3a.53.53 0 00.13-.75.53.53 0 00-.224-.182c-.09-.039-.066-.038-.286-.038z"
              fill="#F2D049"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.49 1.05a1.56 1.56 0 011.973 1.018l2.003 6.142h6.066c.038.001.109.003.189.014.1.014.187.04.264.069l.064.026.023.01c.258.112.48.291.642.52a1.53 1.53 0 01-.352 2.137l-5.035 3.86 1.95 6.11a1.54 1.54 0 01-2.437 1.701l-4.837-3.74-4.849 3.782a1.54 1.54 0 01-1.384.261 1.55 1.55 0 01-1.057-1.94l.004-.013 1.947-6.13-5.056-3.861A1.55 1.55 0 012.61 8.21h5.866l2.037-6.19.002-.007a1.55 1.55 0 01.958-.958l.008-.003.008-.002zm.488 2.915L9.924 10.21H3.848l5.148 3.932-1.935 6.093 4.936-3.851 4.94 3.82-1.943-6.09 5.093-3.904h-6.073l-2.036-6.245z"
              fill="#7C6919"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default StarFilledColoredBoldIcon;
